import React, { useState, useEffect, createContext, useContext } from 'react'
import PropTypes from 'prop-types'

import * as AuthAPI from 'utils/AuthAPI'

const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)

  // App 初次載入時，若已有有效 session 則自動還原 user 狀態
  useEffect(() => {
    AuthAPI.userInfo()
      .then(data => { if (data) setUser(data) })
      .catch(() => {})
  }, [])

  const login = (data) => {
    return AuthAPI.login(data).then(() => {
      return getAccountData()
    })
  }

  const logout = () => {
    return AuthAPI.logout()
      .finally(() => {
        setUser(null)
      })
  }

  const getAccountData = () => {
    return AuthAPI.userInfo().then(data => {
      if (data) {
        setUser(data)
      }
      return data
    })
  }

  const hasRole = (roleName) => {
    return user?.roles?.includes(roleName) || false
  }

  const canManageTokens = () => {
    return hasRole('admin') || hasRole('moderator')
  }

  const value = { user, login, logout, getAccountData, hasRole, canManageTokens }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}

AuthProvider.propTypes = {
  children: PropTypes.object.isRequired
}

export const useAuth = () => {
  return useContext(AuthContext)
}
